<template>
  <div class="question-side-item" v-if="siteConfig.isQa == 1 && isShowAsk">
    <!-- <div class="ask-header">提问</div> -->
    <div class="ask-text">
      <textarea
        v-model="questionContent"
        maxlength="1000"
        placeholder="请输入您的问题"
      ></textarea>
    </div>
    <div class="ask-action clearfix">
      <Upload
        :action="uploaderUrl"
        :headers="uploaderHeaer"
        :data="uploaderData"
        :max-size="2048"
        :before-upload="handleBefore"
        :on-success="handleSuccess"
        :show-upload-list="false"
        class="fl"
      >
        <div
          style="
            width: 60px;
            height: 60px;
            text-align: center;
            border: 1px dashed #999;
            border-radius: 8px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
          "
        >
          <!-- <Icon type="ios-add" /> -->
          <Icon type="md-add" />
          <p style="font-size: 12px">上传图片</p>
        </div>

        <!-- <Icon custom="ich-icon ich-icon-image" /> -->
      </Upload>
      <Button
        type="primary"
        shape="circle"
        class="fr"
        style="width: 100px"
        @click="saveQuestion()"
        >发 表</Button
      >
    </div>
    <div class="ask-image clearfix">
      <span v-for="(item, index) in picFileList" :key="index">
        <a href="javascript:;" title="删除图片" @click="handleRemove">×</a>
        <i></i>
        <img :src="concatImageUrl(item, 73, 73, true)" />
      </span>
      <!-- <span>
        <a href="javascript:;" title="删除图片">×</a>
        <i></i>
        <img :src="concatImageUrl('2020052616565555150.jpg',0,0,true)" />
      </span>-->
    </div>
  </div>
</template>
<script>
import { siteMixin } from "../../utils/mixin";
import { study } from "../../request";
export default {
  mixins: [siteMixin],
  props: {
    position: {
      type: String,
      default: "",
    },
    fromId: {
      type: Number,
      default: 0,
    },
    fromPosition: {
      type: String,
      default: "",
    },
    askType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      uploaderUrl: process.env.VUE_APP_API_URL + "/api/pc/upload",
      uploaderHeaer: {
        Authorization: "Beego aHVhaGFuOmJlZWdvMjAxNQ==",
      },
      uploaderData: {
        dir: "APPIMG",
      },
      questionContent: "",
      picFileList: [],
      picFileName1: "",
      picFileName2: "",
      picfilename3: "",
      location: "",
      isShowAsk: true,
    };
  },
  watch: {
    catalogId() {
      this.initParams();
    },
    fromPosition() {
      this.initParams();
    },
  },
  mounted() {
    this.initParams();
    // 视频学习页，无视频限制提问
    setTimeout(() => {
      if (!this.pptId && this.askType == "ppt") {
        this.isShowAsk = false;
      } else {
        this.isShowAsk = true;
      }
    }, 0);
  },
  methods: {
    initParams() {
      if (this.position == "rev") {
        this.location = "串讲视频 > " + this.fromPosition;
        return;
      }
      if (this.position == "wrong") {
        this.location = `${this.fromPosition} > 错题本`;
        return;
      }
      if (this.position == "fav") {
        this.location = `${this.fromPosition} > 习题收藏`;
        return;
      }
      let simId = 0;
      let catId = 0;
      let regId = 0;
      if (this.position == "cat") catId = this.fromId;
      if (this.position == "sim") simId = this.fromId;
      if (this.position == "reg") regId = this.fromId;
      if (simId == 0 && catId == 0 && regId == 0) return;
      const type = this.askType == "ppt" ? 1 : 0;
      study
        .getAskLocation(simId, catId, regId, this.umcId, type)
        .then((res) => {
          //console.log(res);
          if (res.status === 1) {
            this.location = res.data;
          }
        });
    },
    saveQuestion() {
      console.log(this.pptId, "this.pptId");

      if (!this.questionContent || this.questionContent.trim() == "") {
        this.$Message.error("请输入您的问题");
        return;
      }

      //初始化图片
      this.picFileName1 =
        this.picFileList.length >= 1 ? this.picFileList[0] : "";
      this.picFileName2 =
        this.picFileList.length >= 2 ? this.picFileList[1] : "";
      this.picFileName3 =
        this.picFileList.length >= 3 ? this.picFileList[2] : "";

      //提交数据
      study
        .saveUserQuestion({
          UserId: this.loginUser.userId,
          ExerId: this.exerId,
          UmcId: this.umcId,
          PptId: this.pptId,
          FromPosition: this.location ?? "",
          QContent: this.questionContent.trim(),
          picfilename1: this.picFileName1,
          picfilename2: this.picFileName2,
          picfilename3: this.picFileName3,
        })
        .then((res) => {
          //console.log(res);
          if (res.status === 1) {
            this.questionContent = "";
            this.picFileList = [];
            this.$Message.success("发表成功");
            this.$emit("on-success");
          }
        });
    },
    handleBefore(file) {
      if (this.picFileList.length >= 3) {
        this.$Message.error("最多上传3张图片");
        return false;
      }
    },
    handleRemove(index) {
      this.picFileList.splice(index, 1);
    },
    handleSuccess(res, file, fileList) {
      if (res.Status) {
        this.picFileList.push(res.Url);
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/var.less";
@import "../../assets/css/question.less";
</style>
